module.exports = __webpack_public_path__ + "static/media/Logo_RD_Station.45aea419.svg";